<template lang="pug">
.do(v-if="stat.local_team[0]")
	.do-table.do-table--local(v-if="isLeaders")
		table.ta.ta--le
			thead.ta-section.ta-section--head
				tr.ta-row
					th.ta-col {{ $t("Num.") }}
					th.ta-col.ta-col--name {{ $t("Player") }}
					th.ta-col {{ $t(stat.abbrev)}}
			tbody.ta-section.ta-section--body(v-if="isLocalEmpty")
				tr.ta-row.ta-row--high
					td.ta-col 
					td.ta-col.ta-col--name {{ $t("No results")}}
					td.ta-col 
			tbody.ta-section.ta-section--body(v-else)
				tr.ta-row(
					v-for="(player, index) in stat.local_team"
					:key="index"
					v-if="player.val!=0"
					:class="{'ta-row--high': index==0}"
				)
					td.ta-col {{ player.num }}
					td.ta-col.ta-col--name {{player.name}}
					td.ta-col 
						AnimatedValue(:value="player.val")

	.do-player.do-player--local
		img.do-player__img(v-if="stat.local_team[0].image" :src="isLocalEmpty ? '/local-silhouette.png' : stat.local_team[0].image" loading="lazy")
		img.do-player__img(v-else src='/local-silhouette.png' loading="lazy")
		span(v-show="!isLeaders").do-player__name {{isLocalEmpty ? $t("No results") : stat.local_team[0].name}}
	LeaderGraph(:stat = "stat", :decimals="decimals")
	.do-player.do-player--visitor
		img.do-player__img(v-if="stat.visiting_team[0].image" :src="isVisitorEmpty ? '/visitor-silhouette.png' : stat.visiting_team[0].image" loading="lazy")
		img.do-player__img(v-else src='/visitor-silhouette.png' loading="lazy")
		span(v-if="!isLeaders").do-player__name {{isVisitorEmpty ? $t("No results") : stat.visiting_team[0].name}}
	.do-table.do-table--visitor(v-if="isLeaders")
		table.ta.ta--le
			thead.ta-section.ta-section--head
				tr.ta-row
					th.ta-col.ta-col {{ $t("Num.") }}
					th.ta-col.ta-col--name {{ $t("Player") }}
					th.ta-col {{ $t(stat.abbrev)}}
			tbody.ta-section.ta-section--body(v-if="isVisitorEmpty")
				tr.ta-row.ta-row--high
					td.ta-col 
					td.ta-col.ta-col--name {{ $t("No results")}}
					td.ta-col 
			tbody.ta-section.ta-section--body(v-else)
				tr.ta-row(
					v-for="(player, index) in stat.visiting_team"
					:key="index"
					v-if="player.val!=0"
					:class="{'ta-row--high': index==0}"
				)
					td.ta-col {{ player.num }}
					td.ta-col.ta-col--name {{player.name}}
					td.ta-col 
						AnimatedValue(:value="player.val")
					
</template>

<style lang="sass">

.do
	width: 100%
	max-width: 1200px
	margin: 0 auto
	box-sizing: border-box
	display: grid
	align-items: center
	grid-gap: 1rem
	grid-template-columns: 1fr 60px 60px 1fr
	grid-template-areas: "lplayer graph graph vplayer" "ltable ltable vtable vtable"
	grid-template-rows: auto

	+breakpoint(medium)
		grid-template-columns: 1fr 1fr 1fr
		grid-template-areas: "lplayer graph vplayer" "ltable . vtable"

	+breakpoint(1400px)
		grid-template-columns: 3fr 3fr 2fr 3fr 3fr
		grid-template-areas: "ltable lplayer graph vplayer vtable"
		grid-gap: 2rem

	&-wrap
		display: grid
		grid-auto-flow: row
		grid-gap: 2rem
		justify-items: center
		+breakpoint(medium)
			grid-gap: 2rem
		&--ov
			grid-gap: 2rem
			+breakpoint(800px)
				grid-template-columns: 1fr 1fr
				grid-gap: 3rem 6rem
			.do
				grid-template-columns: 1fr 1fr 1fr
				grid-template-areas: "lplayer graph vplayer"

	&-player
		display: flex
		flex-direction: column
		align-items: center
		&__img
			max-height: 240px
			width: 100%
			object-fit: contain
			//-filter: brightness(110%) contrast(110%)

		&__name
			padding-top: 0.5rem
			font-weight: $bold
			font-size: 0.9em
			+breakpoint(medium)
				font-size: 1.1em
			text-align: center
		&--local
			grid-area: lplayer
		&--visitor
			grid-area: vplayer
	&-table
		//-min-height: 200px
		min-width: 150px
		display: flex
		align-self: start
		&--local
			grid-area: ltable
			justify-content: center
			+breakpoint(1400px)
				justify-content: flex-end
		&--visitor
			grid-area: vtable
			justify-content: center
			+breakpoint(1400px)
				justify-content: flex-start
	&-gra
		width: 100%
		max-height: 160px
		grid-area: graph
		justify-self: center
		*
			transition:  stroke-dasharray 1s
		&--safari
			*
				transition:  stroke-dasharray 0s
</style>

<script>
import LeaderGraph from "@/components/subcomponents/leaders/LeaderGraph.vue";
import AnimatedValue from "@/components/subcomponents/general/AnimatedValue.vue";

export default {
  name: "Leaders",
  props: {
    stat: Object,
	decimals: {
		type: Number,
		default: 0
	}
  },
  computed: {
    isLeaders() {
      return this.$route.name.split(".")[1] == "leaders";
    },
    isLocalEmpty() {
      if (this.$props.stat) return this.$props.stat.local_team[0].val == 0;
      else return false;
    },
    isVisitorEmpty() {
      if (this.$props.stat) return this.$props.stat.visiting_team[0].val == 0;
      else return false;
    }
  },
  components: {
    LeaderGraph,
    AnimatedValue
  },
  mounted() {
    if (this.$props.stat.name == "Asistencias")
      this.$store.commit("general/setLeadersReady", true);
  }
};
</script>
